export default __webpack_public_path__ + "static/media/espm_logo.cecdef83.png";